import { useState } from 'react'
import { Box, Button, Typography, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'
import { InfoCardIcon } from 'components/atoms/Icons'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { GridInfoCard } from 'components/atoms/InfoCard'
import { Trans, useTranslation } from 'react-i18next'
import timerIcon from 'assets/images/timer.svg'
import shielldTickIcon from 'assets/images/shieldTick.svg'
import taskListPenIcon from 'assets/images/taskListPen.svg'
import sheildWaveIcon from 'assets/images/sheildWave.svg'
import boltIcon from 'assets/images/bolt.svg'
import leadersIcon from 'assets/images/leaders.svg'

import HeaderWithInfoCards, {
  Welcome
} from 'components/atoms/container/HeaderWithInfoCards'
import { ActionText } from 'components/atoms/Text'
import { getLocalUser } from 'utils/localStorage'
import { desctructUser } from 'utils/formatText'
import InfoDialog from '../notificationOverlay/InfoDialog'
import InCardStack from 'components/atoms/container/InCardStack'
import colors from 'styles/colors'

export const MoreOnConfidentiality = () => {
  const { t } = useTranslation()
  const [confidentialDialogOpen, setDisplayConfidentialInfo] = useState(false)

  const RenderConPoint = ({ i18nKey }) => (
    <Typography variant='body1' color={colors.Grey400}>
      <Trans i18nKey={i18nKey} />
    </Typography>
  )

  return (
    <>
      <ActionText
        variant='body1Small'
        fontWeight='500'
        sx={{ alignItems: 'center', display: 'flex', marginTop: 10 }}
        onClick={() => setDisplayConfidentialInfo(true)}>
        <InfoOutlinedIcon sx={{ marginRight: 2 }} />
        {t('assessments.landingMoreConfidentiality')}
      </ActionText>

      <InfoDialog
        open={confidentialDialogOpen}
        onClose={() => setDisplayConfidentialInfo(false)}
        buttonText={t('rolePlay.okay')}
        sx={{ '& .MuiDialog-paper': { maxWidth: 720 } }}>
        <InCardStack spacing={4} sx={{ textAlign: 'start' }}>
          <IconButton
            sx={{
              position: 'absolute',
              right: 10,
              top: 20,
              color: colors.Grey300
            }}
            onClick={() => setDisplayConfidentialInfo(false)}>
            <Close />
          </IconButton>
          <Typography variant='h3' width={'100%'}>
            {t('confidentiality.takeConfidentialitySeriously')}
          </Typography>
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part1' />
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part2' />
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part3' />
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part4' />
          <RenderConPoint i18nKey='confidentiality.otherAssessment.part5' />
        </InCardStack>
      </InfoDialog>
    </>
  )
}

const AssessmentLanding = ({
  selfAssessment,
  goalName,
  questionCount,
  handleBegin,
  assessmentSenderName
}) => {
  const { t } = useTranslation()
  const [firstName, ,] = desctructUser(getLocalUser())

  return selfAssessment ? (
    <HeaderWithInfoCards
      welcomeElement={
        <Welcome
          title={t('assessments.selfAssessment')}
          description={
            <Trans
              i18nKey='assessments.selfAssessmentLanding'
              values={{ goalName }}
            />
          }>
          <Box sx={{ paddingTop: 6 }}>
            <Button sx={{ textWrap: 'nowrap' }} onClick={handleBegin}>
              {t('assessmentTimeline.beginSelfAssessment')}
            </Button>
          </Box>
        </Welcome>
      }>
      <GridInfoCard
        title={t('assessments.landingQuestionTitle', {
          count: questionCount
        })}
        content={t('assessments.selfLandingQuestion', { count: questionCount })}
        icon={<InfoCardIcon src={timerIcon} size={56} />}
      />
      <GridInfoCard
        title={t('headers.aboutConfidentiality')}
        content={t('assessments.selfLandingConfidentiality')}
        icon={<InfoCardIcon src={shielldTickIcon} size={56} />}
      />
      <GridInfoCard
        title={t('assessments.selfLandingStarting')}
        content={t('assessments.selfLandingStartDescription')}
        icon={<InfoCardIcon src={taskListPenIcon} size={56} />}
      />
    </HeaderWithInfoCards>
  ) : (
    <HeaderWithInfoCards
      containerSx={{ marginTop: 16 }}
      welcomeElement={
        <Welcome
          headLine={`${t('rolePlay.hi')}, ${firstName}`}
          title={t('assessmentForOthers.assessmentFor', {
            assessmentSenderName
          })}
          description={t('assessmentForOthers.feedbackOnBehaviour', {
            assessmentSenderName
          })}>
          <Box sx={{ paddingTop: 6 }}>
            <Button sx={{ textWrap: 'nowrap' }} onClick={handleBegin}>
              {t('assessmentForOthers.startUserAssessment', {
                assessmentSenderName: assessmentSenderName.split(' ')[0]
              })}
            </Button>
          </Box>
        </Welcome>
      }>
      <GridInfoCard
        title={t('headers.aboutConfidentiality')}
        content={t('assessmentForOthers.toProtectPrivacy', {
          assessmentSenderName
        })}
        icon={<InfoCardIcon src={sheildWaveIcon} size={64} />}>
        <MoreOnConfidentiality />
      </GridInfoCard>
      <GridInfoCard
        title={t('assessmentForOthers.fastStreamlined')}
        content={t('assessmentForOthers.assessmentConsistsOf', {
          count: questionCount
        })}
        icon={<InfoCardIcon src={boltIcon} size={64} />}
      />
      <GridInfoCard
        title={t('assessmentForOthers.leadershipDevelopment')}
        content={t('assessmentForOthers.diversePerspectives', {
          assessmentSenderName
        })}
        icon={<InfoCardIcon src={leadersIcon} size={64} />}
      />
    </HeaderWithInfoCards>
  )
}

export default AssessmentLanding
